var map = {
	"./assets/politics-app-cta.png": 33,
	"./assets/winner.png": 3,
	"./images/clinton.jpg": 34,
	"./images/other.png": 35,
	"./images/sanders.jpg": 36
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;



/*****************
 ** WEBPACK FOOTER
 ** ./src/media ^\.\/.*\.*
 ** module id = 70
 ** module chunks = 0
 **/